import { useContext } from 'react';
import { FilterContext } from 'components/filter/filters-next/FilterContext';
import { FilterGroupContext } from 'components/filter/filters-next/FilterGroupContext';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { FilterValue } from 'components/filter/types';

const useCurrentFilter = <T>() => {
    const { groupId } = useContext(FilterGroupContext);
    const { cacheKey, nodeId, strategyType, readOnlyFilter } = useContext(FilterContext);
    const { currentGroup } = useFiltersByKey(cacheKey, groupId);
    const possibleFilterFromCache = strategyType
        ? currentGroup?.filters?.find(f => f.id === nodeId)
        : undefined;

    return (possibleFilterFromCache ?? readOnlyFilter) as FilterValue<T> | undefined;
};

export { useCurrentFilter };
